// Reihenfolge vom Betreiber festgelegt (27.10.2026).
// Alle Namen werden einheitlich dargestellt (Akzentfarbe nur für Links).
export const COLLABORATIONS = [
  "Michelin Guide", "El Celler de Can Roca", "The Fontenay",
  "Der Feinschmecker", "Haerlin", "Lakeside",
  "bianc", "Tohru in der Schreiberei", "Zeik",
  "Reichshof Hamburg", "Casamar", "L'Aliança d'Anglès",
  "Ophelia", "Witwenball Küche & Wein", "Leica Store Hamburg",
];
